module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dfd4db403fda18c92ebfd0e6851826e5.png";